module.exports = __webpack_public_path__ + "img/meeting_info.cff46969.png";